export const state = () => ({
  token: null,
  user: null,
  showLogin: false
})
export const mutations = {
  setUser(state,  user) {
    state.user = user
  },
  setToken(state, token) {
    state.token = token
  },
  clearUserData(state) {
    state.token = null
    state.user = null
  },
  setShowLogin(state, showLogin) {
    state.showLogin = showLogin
  },
}
export const actions = {
  async login({ commit }, { username, password, remember }) {
    try {
      const response = await this.$api.post('/login', { username, password })
      if (response.code !== 200) { return response }
      const data = response.data
      const expires = remember ? new Date(Date.now() + 7 * 24 * 60 * 60 * 1000) : null
      this.$cookies.set('token', data.token, { 
        path: '/',
        expires,
        maxAge: remember ? 7 * 24 * 60 * 60 : undefined
      })
      const res = await this.$api.get('/users/info')
      const user = res.data
      commit('setUser', user)
      return { success: true, }
    } catch (err) {
      return { 
        success: false, 
        message: err.response ? err.response.message : '登录失败' 
      }
    }
  },
  logout({ commit }) {
    commit('clearUserData')
    this.$cookies.remove('token')
    this.$router.push('/')
  },
  async initAuth({ commit }) {
    const token = this.$cookies.get('token')
    if (token) {
      try {
        const res = await this.$api.get('/users/info')
        const user = res.data
        commit('setUser', user )
      } catch (err) {
        this.$cookies.remove('token')
      }
    }
  },
  async autoLogin ({ commit }, secret_token) {
    try {
      const response = await this.$api.post('/login', { 'secret_token': secret_token })
      if (response.code !== 200) { return false }
      const data = response.data
      const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
      this.$cookies.set('token', data.token, { 
        path: '/',
        expires,
        maxAge: 7 * 24 * 60 * 60
      })
      const res = await this.$api.get('/users/info')
      const user = res.data
      commit('setUser', user )
    } catch (err) {
      this.$cookies.remove('token')
    }
  },
}